export default "__VITE_ASSET__DnFSc2kZ__"